import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { useCohortBuilderData } from '@verantos-dev/data-access-cohorts';
import { useGetNewDatasetReleaseByIdQuery } from '@verantos-dev/data-access-datasets';

dayjs.extend(utc);

export type DatasetDateBounds = {
  minDate: Dayjs | null;
  maxDate: Dayjs | null;
  hasDataBounds: boolean;
};

export const useDatasetDateBounds = (): DatasetDateBounds => {
  const { data: cohortData } = useCohortBuilderData();
  const releaseId = cohortData?.data?.latestDatasetReleaseId;
  const { data: datasetDetails } = useGetNewDatasetReleaseByIdQuery(releaseId ?? '', {
    skip: !releaseId,
  });

  const dataStartDate = datasetDetails?.data?.dataStartDate;
  const dataEndDate = datasetDetails?.data?.dataEndDate;

  return {
    minDate: dataStartDate ? dayjs.utc(dataStartDate) : null,
    maxDate: dataEndDate ? dayjs.utc(dataEndDate) : null,
    hasDataBounds: !!(dataStartDate && dataEndDate),
  };
};
